import { cn } from '@/lib/cn';

const sizes = {
  sm: 16,
  md: 24,
  lg: 32,
  xl: 48,
} as const;

interface LogoSpinnerProps {
  size?: keyof typeof sizes;
  className?: string;
}

export function LogoSpinner({ size = 'md', className }: LogoSpinnerProps) {
  const dimension = sizes[size];
  return (
    <img
      src="/logo.svg"
      alt=""
      width={dimension}
      height={dimension}
      className={cn('logo-spin', className)}
    />
  );
}
